export const DashboardHeadingDataHook = 'wsr-heading';
